import Auth from "@aws-amplify/auth";
import { attachAuthHubListner } from "src/utils/userDeeplink";

/**
 * These values will become dynamic per each env once the ErgonaCDK is complete.
 */
const REGION = "us-east-1";
const IDENTITY_POOL_ID = "us-east-1:682393e0-b1e8-4809-9da4-1a5c35254555";
const USER_POOL_ID = "us-east-1_5id78u0c7";
const WEB_CLIENT_ID = "2ss7jisquj57fbrjpfde4kfm2k";
const DOMAIN = `ergona-gamma-global.auth.us-east-1.amazoncognito.com`;

export async function Init(): Promise<void> {
  const config = {
    stage: "gamma",
    aws_cognito_region: REGION,
    aws_cognito_identity_pool_id: IDENTITY_POOL_ID,
    aws_user_pools_id: USER_POOL_ID,
    aws_user_pools_web_client_id: WEB_CLIENT_ID,
    Auth: {
      region: REGION,
      identityPoolId: IDENTITY_POOL_ID,
      userPoolId: USER_POOL_ID,
      userPoolWebClientId: WEB_CLIENT_ID,
    },
    oauth: {
      domain: DOMAIN,
      redirectSignIn: "https://gamma.ergona.whs.amazon.dev",
      redirectSignOut: "https://gamma.ergona.whs.amazon.dev",
      scope: ["openid", "profile", "email"],
      responseType: "code",
    },
  };
  Auth.configure(config);
  attachAuthHubListner();
}
